<template>
    <div style="position: relative;">
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="video" v-show="video">
            <div class="center">
                <div class="icon icon_close" title="关闭" @click="show_home_video('0')"></div>
                <video class="video-js" preload="auto" :src="mp4Url" style="width:100%;height:100%;" controls :poster="cover" :muted="muteStatus" :autoplay="playStatus" ></video>
            </div>
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">企业荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiZiZhi')">公司资质</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('DangJianGongHui')">党建工会</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeHuaCe')">企业画册</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeXuanChuanPian')">企业宣传片</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>公司简介<span @click="show_language('c')" v-if="language == 'e'">中文</span><span @click="show_language('e')" v-else-if="language == 'c'">English</span></h2>
                    <!-- <div class="main_album">
                        <img src="http://www.corner.com.cn/profile/upload/2024/03/01/0001_20240301094217A268.jpg" />
                    </div> -->
                    <div class="jieshao" v-if="language == 'c'">
                        <div style="width:900px;zoom:1;overflow:auto;">
                            <div style="float:left;width:500px;">
                                <b>一、基本情况</b>
                                <p style="text-align:justify;">哈尔滨凯纳科技股份有限公司（以下简称“凯纳科技”）成立于<em>1995</em>年，现有员工<em>350</em>余人，其中<em>50%</em>以上为研发人员，是<em>国家级高新技术企业</em>、<em>“专精特新”企业</em>。<em>凯纳科技将物联网、大数据、人工智能应用在供排水、环保、水文水利等民生领域，有国内领先的物联网开放平台，是国内智慧供水领先企业</em>。凯纳科技以“智慧物联，感知世界”为愿景，秉承“惠济民生、服务社会”的使命，践行“立己立人、利人利己”的价值观，持续推进数字化及智能制造领域的创新与发展。</p>

                            </div>
                            <div style="float:left;width:400px;text-align:right;">
                                <img src="http://www.corner.com.cn/profile/upload/2024/03/01/0001_20240301094217A268.jpg" style="width:90%;height:auto;border-radius:10px;vertical-align:top;" />
                            </div>
                        </div>
                        <b>二、核心竞争力</b>
                        <p>凯纳科技用现代控制理论结合流体力学发明智慧泵站，用于东北三省、北京，并参与制定两项地方技术标准。凯纳科技坚持创新驱动发展，研发投入逐年递增，已设立黑龙江省级和哈尔滨市级企业技术中心，黑龙江省工程技术研究中心，黑龙江智能制造数据采集院士工作站，哈尔滨市级新型研发机构，哈尔滨市工业设计中心，成为黑龙江省级和市级创新示范企业，黑龙江省中小企业数字化示范标杆企业，黑龙江省工业互联网新模式新业态示范企业，哈尔滨市服务型制造业示范企业。凯纳科技与多家科研机构合作，并在西安、杭州设立研发中心，在三亚设立科贸中心。目前与哈工大三个学院合作，已成立智慧水务产业技术研究院，由省科技厅、省工信厅、哈工大联合授牌，为智慧水务全产业链提供技术支撑，引领创新驱动发展。与黑龙江职业信息技术学院、黑龙江农垦职业学院建立产教融合基地、哈尔滨市和黑龙江省博士后创新实践基地、黑龙江省产教融合性试点企业，为龙江培养工匠人才。</p>
                        <p>建立建全党组织，吸纳、培养优秀青年加入党组织，企业党组织是哈尔滨新区优秀党支部。</p>
                        <p>凯纳科技先后承建国家级重点研发项目五个，省市级科技项目十个，取得50余项发明专利、200余项软件产品著作权及科技成果证书，其中五项获得国家级奖项，形成了具有自主知识产权的产品系列。</p>
                        <p><em>凯纳水力模型、智慧泵站、水质分析仪、营收系统、DMA分区计量系统、漏损检测系统、智慧水务平台等产品覆盖智慧供水的全过程，利用人工智能，提高供水行业的治理能力，降低能耗、延长设备的使用寿命、提高水资源的利用率，推出智慧泵站新标准，引领行业进步及产业升级。凯纳科技自主研发传感器、数据关系中间件、数字孪生系统、AI智能分析模型及物联网平台等在城市生命线建设中发挥了巨大作用。</em></p>
                        <p>凯纳分户式农村生活污水智能处理系统，将农户生活污水及厕所废水收集到一体化污水处理设备中，通过物联网智能无人值守管控平台控制污水处理过程，处理后的出水到达农田灌溉水质，实现农村生活污水的资源化利用。</p>
                        <br />
                        <b>三、业绩及发展规划</b>
                        <p>凯纳科技于2010年开始致力于物联网业务的开发及应用，目前在智慧水务领域形成了比较有竞争力的系列产品。制定的黑龙江省地方标准《黑龙江省城镇二次供水系统智慧泵房应用技术规程》、《黑龙江省城镇智慧供热工程技术规程》正式发布并实施。</p>
                        <p>凯纳科技有国内最领先的智慧泵站管理系统，用于哈尔滨的智慧供水和老旧泵站的全面改造，引领智慧供水全面升级，带动行业进步。省内的哈尔滨、绥化、佳木斯、双鸭山、鹤岗、七台河、鸡西、齐齐哈尔、黑河都已经陆续应用，为全省智慧供水发展作出巨大贡献，现在正面向全国应用。国内很多发达城市，北京、深圳、合肥主动找凯纳科技合作。沈阳供水集团专程到哈尔滨学习，全面采用凯纳科技的智慧泵站管理系统在沈阳应用。</p>
                        <p><em>未来，凯纳科技将持续深耕智慧水务领域，抓住契机走出国门，将产品和技术应用到更多国家，不断提升核心竞争力，充分发挥技术优势，为百姓用水安全保驾护航，为我国城市发展和改善城镇及农村供排水智慧化做出更大的贡献！</em></p>

                        <br />
                        <b>四、公益事业与奖励</b>
                        <p>凯纳科技致富思源，回报社会。近五年公益事业捐赠超千万元，是全省精准扶贫先进个人，抗击新冠疫情先进集体。2016年获市非公经济纳税百强企业；2017年获首届省政府质量奖提名奖；2020年自主研发产品获黑龙江省政府科学技术奖，2021年认定为全国就业与社会保障先进民营企业，2022年荣获哈尔滨市第38届模范单位（集体）。2023年多人被评为省高层次人才、科技创新领军人才、科技创业领军人才，获得市科技局创新人才项目专项奖励。</p>

                        <b>五、资质荣誉</b>
                        <p>◊ &nbsp; 高新技术企业认定证书<br />
                            ◊ &nbsp; 两化融合管理体系评定证书<br />
                            ◊ &nbsp; 市政公用工程施工总承包资质<br />
                            ◊ &nbsp; 哈尔滨市非公经济纳税百强企业<br />
                            ◊ &nbsp; 黑龙江省政府质量奖提名奖<br />
                            ◊ &nbsp; 全国就业与社会保障先进民营企业<br />
                            ◊ &nbsp; 哈尔滨市第38届模范单位（集体）<br />
                            ◊ &nbsp; 哈尔滨市民营科技创新企业30强<br />
                            ◊ &nbsp; 黑龙江软件和信息服务业20强<br />
                            ◊ &nbsp; 黑龙江省诚信建设示范企业<br />
                            ◊ &nbsp; 哈尔滨市政府科学技术奖<br />
                            ◊ &nbsp; 黑龙江省政府科学技术奖<br />
                            ◊ &nbsp; 黑龙江省软件与信息服务业统计工作先进单位<br />
                            ◊ &nbsp; 哈尔滨名牌战略推进委员会评为哈尔滨名牌企业<br />
                            ◊ &nbsp; 哈尔滨市建设培育产教融合型企业<br />
                            ◊ &nbsp; 哈尔滨市青年就业见习基地<br />
                            ◊ &nbsp; 黑龙江省中小企业数字化示范标杆企业<br />
                            ◊ &nbsp; 哈尔滨市博士后创新实践基地<br />
                            ◊ &nbsp; 黑龙江省博士后创新实践基地<br />
                            ◊ &nbsp; 黑龙江省产教融合性试点企业<br />
                            ◊ &nbsp; 第八届“创客中国”中小企业创新创业大赛全国500强<br />
                            ◊ &nbsp; 黑龙江省制造业单项冠军（产品）<br />
                            <a href="#/GongSiZiZhi" class="link">查看资质详情</a><a href="#/ZiZhiRongYu" class="link">查看荣誉详情</a>
                        </p>


                        <!--<p>哈尔滨凯纳科技股份有限公司（以下简称“凯纳科技”）成立于1995年，总资产五亿元，现有员工230余人，其中70%以上为研发人员，80%以上人员具有中、高级职称，是国家级高新技术企业、“专精特新”企业。凯纳科技专注于物联网、大数据、人工智能在供排水、环保、水文水利等民生领域的应用，有国内领先的物联网开放平台，是国内智慧供水领先企业。凯纳科技以“智慧物联，感知世界”为愿景，秉承“惠济民生、服务社会”的使命，践行“立己立人、利人利己”的价值观，持续推进数字化及智能制造领域的创新与发展。</p>
                        <p>凯纳科技用现代控制理论结合流体力学发明智慧泵站，用于东北三省、北京，并参与制定两项地方技术标准。凯纳科技坚持创新驱动发展，研发投入逐年递增，已设立黑龙江省级和哈尔滨市级企业技术中心，黑龙江省工程技术研究中心，黑龙江智能制造数据采集院士工作站，哈尔滨市级新型研发机构，成为黑龙江省级和市级创新示范企业。凯纳科技与多家科研机构合作，并在西安、杭州设立研发中心，在三亚设立科贸中心，很快会在日本设立合作创新平台。目前与哈工大三个学院合作，已成立智慧水务产业技术研究院，由省科技厅、省工信厅、哈工大联合授牌，为智慧水务全产业链提供技术支撑，引领配套产业发展。与黑龙江职业信息技术学院、黑龙江农垦职业学院建立产教融合基地，为龙江培养工匠级人才。到新区八年累积纳税超两亿元，评为2022年度民营经济科技创新30强。建立建全党组织，吸纳、培养优秀青年加入党组织，企业党组织是哈尔滨新区优秀党支部。凯纳科技先后承建国家级重点信息化项目五个，省市级科技项目十个，取得50余项发明专利、100余项软件产品著作权及科技成果证书，其中五项获得国家级奖项，形成了具有自主知识产权的产品系列。制定的黑龙江省地方标准《黑龙江省城镇二次供水系统智慧泵房应用技术规程》、《黑龙江省城镇智慧供热工程技术规程》正式发布并实施。</p>
                        <p>凯纳泵站智慧管理系统、凯纳水质分析仪、营收系统、漏损检测系统、智慧水务平台等产品覆盖智慧供水的全过程，利用实时数据，提高供水行业的治理能力，降低能耗、延长设备的使用寿命、提高水资源的利用率，推出智慧泵站新标准，引领行业进步产业升级。凯纳科技自主研发传感器、数据关系中间件、数字孪生系统、AI智能分析模型及物联网平台等在城市生命线建设中发挥了巨大作用。</p>
                        <p>凯纳分户式农村生活污水智能处理系统，将农户生活污水及厕所废水收集到一体化污水处理设备中，通过物联网智能无人值守管控平台控制污水处理过程，处理后的出水到达农田灌溉水质，实现农村生活污水的资源化利用。</p>
                        <p>凯纳科技与华为公司合作研发物联网容器，完全国产化实现自主可控，在华为平台全国销售。凯纳科技有国内最领先的智慧泵站管理系统，用于哈尔滨的智慧供水和老旧泵站的全面改造，引领智慧供水全面升级，带动产业进步。省内的哈尔滨、绥化、佳木斯、双鸭山、鹤岗、七台河、鸡西、齐齐哈尔、黑河都已经陆续应用，为全省智慧供水发展作出巨大贡献，现在正面向全国应用。国内很多发达城市，北京、深圳、合肥主动找凯纳科技合作。沈阳供水集团专程到哈尔滨学习，全面采用凯纳科技的智慧泵站管理系统在沈阳应用。凯纳科技抓住契机走出国门，将产品和技术应用到更多国家，为城市发展、为改善城镇及农村供排水智慧化做出更大的贡献。</p>-->
                    </div>
                    <div class="jieshao" v-else-if="language == 'e'">
                        <p>Harbin Corner Technology Co., Ltd. was established in 1995.  Currently, we have over 350 employees.  Amoun them, over 50% are researchers and engineers.  Corner Technology use information and communication technology to promote the exploration and innovation of IoT products, providing an intelligent, convenient, and comfortable working and living environment.  We have applied Internet of Things, big data, cloud computing, edge computing, artificial intelligence and other technologies to water supply, drainage, environmental protection, heat supply, water conservancy, agriculture, letters and visits and other related fields.  Corner Technology have become a leading enterprise in the application of IoT and information communication technology in Heilongjiang Province.</p>
                        <p>Corner Technology has successively undertaken five national key information technology projects and ten provincial and municipal level technology projects. We have over 50 invention patents, over 200 software product copyrights.  These technological achievements enabled us to have a product series with independent intellectual property rights.  We have participated in establishing the local standards in Heilongjiang Province, including the "Technical Regulations for the Application of Intelligent Pump Houses in Urban Secondary Water Supply Systems in Heilongjiang Province" and the "Technical Regulations for Intelligent Heating Engineering in Urban Areas in Heilongjiang Province".</p>
                        <p>Corner Technology has independently developed products including data transmission units (DTUs), leak detectors, hydrological telemetry terminals, water quality analyzers, remote water supply terminal units, intelligent remote water meters, and more.  Our software products applied in the smart water industry include pump station smart management system, operating fee system, water supply pipeline geographic information system, leakage control system, operation control system, hydraulic water quality model of water transmission and distribution system, customer service platform, monitoring and management system for vulnerable points, drainage pipeline GIS system, manhole cover monitoring system, water level monitoring system, water quality monitoring system, and other full business chain smart water management series products. </p> 
                        <p>In the future, Corner Technology will focus on the research and application of IoT products. Serving the livelihood fields of water supply, drainage, environmental protection, gas, heating, water conservancy, etc.</p>
                    </div>
                    
                    <!-- <div id="contnet">
                        <p v-html="webDescription"></p>
                    </div> -->

                    <h2>企业展示</h2>
                    <p style="text-align:center;"><img src="http://www.corner.com.cn/profile/upload/2023/05/17/1_20230517111627A013.jpg" style="width: 920.219px;"></p>
                    
                    <h2>视频介绍</h2>
                    <ul class="video_list">
                        <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner.mp4')"><img src="../assets/img/video_4.jpg" /><span>凯纳智慧供水软件产品介绍&nbsp;(1'40")</span></div></li>
                        <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_sbtjs.mp4')"><img src="../assets/img/video_5.jpg" /><span>凯纳智慧泵站/数字双胞胎介绍&nbsp;(0'26")</span></div></li>
                        <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_bzzhgl_1.mp4')"><img src="../assets/img/video_6.jpg" /><span>凯纳泵站智慧管理系统&nbsp;(2'07")</span></div></li>
                        <li><div @click="show_home_video('1','http://www.corner.com.cn/video/corner_ncwscl.mp4')"><img src="../assets/img/video_7.jpg" /><span>凯纳农村污水处理系统&nbsp;(3'26")</span></div></li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { GuanYuKaiNa } from "../request/api"; // 导入接口


export default {
    name: 'Home',
    data() {
        return {
            title: '公司简介',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            webTitle:'',
            webDescription:'',

            video: false,
            cover: '',// 封面
            muteStatus: false, // 是否静音自动播放
            playStatus: false, //是否自动播放
            mp4Url:'',

            language: 'c', //c中文，e英文

        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.GongSiJianJie_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        show_language( e ){
            window.scrollTo({
            top: 340,
            behavior: "smooth"
        });
            this.language = e;
        },
        goTo(e) {
            this.$router.push(e);
        },
        GongSiJianJie_data(){ //公司简介
            GuanYuKaiNa({
            }).then((res) => {
                console.log( res );
                this.webTitle = res.rows[0].webTitle;
                this.webDescription = res.rows[0].webDescription;
            });
        },
        show_home_video( e,url ){
            if( e == 1 ){
                this.video = true;
                this.playStatus = true;
                this.muteStatus = false;
                this.mp4Url = url;
            }else{
                this.video = false;
                this.playStatus = false;
                this.muteStatus = false;
                this.mp4Url = '';
            };
            
        },
    },
};
</script>
<style lang="less" scoped>
.right_contnet{
    h2{
        position: relative;
        span{
            user-select: none;
            cursor: pointer;
            position: absolute;
            display: inline-block;
            top: 30px;
            right: 0px;
            font-size:14px;
            width: 70px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #fff;
            border-radius: 3px;
            background-color: #D6000F;
        }
    }

}
.main_album{
    width: 100%;
    margin: 20px 30px 10px 30px;
    text-align: center;
    img{
        border-radius: 10px;
    }
}
.jieshao{
    zoom:1;
    margin: 20px 30px 0px 30px;
    overflow: hidden;
    font-size:14px;
    line-height:200%;
    display:inline-block;
    color:#333;
    p{
        margin: 0px 30px 10px 30px;
        a{
            margin: 15px 0px 5px 10px;
            text-decoration: none;
            color:#999;
            display: inline-block;
            padding: 0px 10px;
            border:1px solid #fff;
        }
        a:hover{
            border: 1px solid #D6000F;
            color:#D6000F;
        }
    }
    em{
        font-style: normal;
        color:#000;
        font-weight: bold;
    }
}
.video_list{
    margin: 10px 30px;
    background-color: #ccc;

    li{
        float: left;
        width:33.333333%;
        text-align: center;
        padding: 10px 0px;

        div{
            margin: 0px auto;
            width: 300px;
            height: 209px;
            background-color: #f0f0f0;
            border-radius: 10px;
            overflow: hidden;

            span{
                height: 35px;
                line-height: 35px;
                color:#171615;
                font-size: 13px;
            }

            img{
                width: 300px;
                height: 169px;
                vertical-align: top;
                filter: blur(0px);
            }
        }
    }
    li:hover{
        cursor: pointer;
        div{
            box-shadow: 0px 0px 10px rgba( 0,0,0,0.5 );
            img{
                animation: li_img_hover 0.5s linear forwards;
                
                @keyframes li_img_hover {
                    0% {
                        filter: blur(0px);
                    }
                    50% {
                        filter: blur(2px);
                    }
                    100% {
                        filter: blur(0px);
                    }
                }

            }
        }
    }
}

.video{
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 99;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.8);
    text-align: center;

    .center{
        position: relative;
        margin: 8% auto 10% auto;
        width: 960px;
        height: 540px;
        background-color: #000;
        border-radius: 10px;

        .icon{
            cursor: pointer;
            position: absolute;
            z-index: 99;
            top: -30px;
            right: -70px;
            width: 50px;
            height: 50px;
            border-radius: 100px;
            background-position: center center;
            background-size: 30px 30px;
            background-color: rgba(0, 0, 0, 0.5);
        }
        .icon:hover{
            background-color: rgba(0, 0, 0, 0.9);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/GongSiJianJie.vue